module.exports = __webpack_public_path__ + "img/water.b6ebdae1.png";